export default "__VITE_ASSET__cb98aa6c__"